import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { PenBridleConfigDto } from 'models/pen/PenBridleConfig';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenBridleConfigService extends BaseApiService<PenBridleConfigDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenBridleConfigDto);
  }

  async getPenBridleConfigs(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenBridleConfigDto[]>(`api/pen-bridle-config/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }
}
